// US states (abbreviations) for the delivery dropdown + shipping cost logic.

export const US_STATES = [
  { code: "AL", name: "Alabama" },
  { code: "AK", name: "Alaska" },
  { code: "AZ", name: "Arizona" },
  { code: "AR", name: "Arkansas" },
  { code: "CA", name: "California" },
  { code: "CO", name: "Colorado" },
  { code: "CT", name: "Connecticut" },
  { code: "DE", name: "Delaware" },
  { code: "DC", name: "District of Columbia" },
  { code: "FL", name: "Florida" },
  { code: "GA", name: "Georgia" },
  { code: "HI", name: "Hawaii" },
  { code: "ID", name: "Idaho" },
  { code: "IL", name: "Illinois" },
  { code: "IN", name: "Indiana" },
  { code: "IA", name: "Iowa" },
  { code: "KS", name: "Kansas" },
  { code: "KY", name: "Kentucky" },
  { code: "LA", name: "Louisiana" },
  { code: "ME", name: "Maine" },
  { code: "MD", name: "Maryland" },
  { code: "MA", name: "Massachusetts" },
  { code: "MI", name: "Michigan" },
  { code: "MN", name: "Minnesota" },
  { code: "MS", name: "Mississippi" },
  { code: "MO", name: "Missouri" },
  { code: "MT", name: "Montana" },
  { code: "NE", name: "Nebraska" },
  { code: "NV", name: "Nevada" },
  { code: "NH", name: "New Hampshire" },
  { code: "NJ", name: "New Jersey" },
  { code: "NM", name: "New Mexico" },
  { code: "NY", name: "New York" },
  { code: "NC", name: "North Carolina" },
  { code: "ND", name: "North Dakota" },
  { code: "OH", name: "Ohio" },
  { code: "OK", name: "Oklahoma" },
  { code: "OR", name: "Oregon" },
  { code: "PA", name: "Pennsylvania" },
  { code: "RI", name: "Rhode Island" },
  { code: "SC", name: "South Carolina" },
  { code: "SD", name: "South Dakota" },
  { code: "TN", name: "Tennessee" },
  { code: "TX", name: "Texas" },
  { code: "UT", name: "Utah" },
  { code: "VT", name: "Vermont" },
  { code: "VA", name: "Virginia" },
  { code: "WA", name: "Washington" },
  { code: "WV", name: "West Virginia" },
  { code: "WI", name: "Wisconsin" },
  { code: "WY", name: "Wyoming" },
];

const NO_DELIVERY = ["AK", "HI"];
const EAST_COAST_22 = ["ME", "NH", "VT", "MA", "RI", "PA", "DE", "MD", "DC", "VA", "WV", "NC", "SC", "GA", "FL"];
const WEST_COAST_45 = ["CA", "OR", "WA"];

// First 3 digits of ZIP codes covering the 5 boroughs of New York City.
const NYC_ZIP3 = ["100", "101", "102", "103", "104", "110", "111", "112", "113", "114", "116"];

const isNycZip = (zip) => NYC_ZIP3.includes(String(zip || "").trim().slice(0, 3));

// Returns { cost, blocked, message, ready }
export function computeShipping(stateCode, zip) {
  if (!stateCode) return { cost: 0, blocked: false, message: "", ready: false };

  if (NO_DELIVERY.includes(stateCode)) {
    return {
      cost: 0,
      blocked: true,
      message: "We're sorry — we don't deliver to Alaska or Hawaii.",
      ready: true,
    };
  }

  if (stateCode === "NY") {
    return { cost: isNycZip(zip) ? 10 : 15, blocked: false, message: "", ready: true };
  }
  if (stateCode === "NJ" || stateCode === "CT") {
    return { cost: 15, blocked: false, message: "", ready: true };
  }
  if (EAST_COAST_22.includes(stateCode)) {
    return { cost: 22, blocked: false, message: "", ready: true };
  }
  if (WEST_COAST_45.includes(stateCode)) {
    return { cost: 45, blocked: false, message: "", ready: true };
  }
  return { cost: 40, blocked: false, message: "", ready: true };
}
